const formatLengthUnit = (length_unit: "imperial" | "metric" | string) => {
  if (length_unit === "imperial") {
    return "ft"
  } else if (length_unit === "metric") {
    return "m"
  } else {
    return ""
  }
}

export default formatLengthUnit
